module.exports = __webpack_public_path__ + "img/web3.09ac06e9.png";